// First-touch marketing attribution: captures UTM parameters + referrer once
// per session so enquiry submissions carry them even after in-site navigation.

const KEY = "blz_attr";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

export function captureAttribution() {
  try {
    if (sessionStorage.getItem(KEY)) return;
    const q = new URLSearchParams(window.location.search);
    const data = { referrer: document.referrer || null, landing_page: window.location.pathname };
    let hasUtm = false;
    for (const k of UTM_KEYS) {
      data[k] = q.get(k);
      if (data[k]) hasUtm = true;
    }
    // Only store when there is something worth keeping; otherwise leave the
    // slot open in case the visitor later arrives via a tagged link.
    if (hasUtm || data.referrer) sessionStorage.setItem(KEY, JSON.stringify(data));
  } catch (_) {
    // storage unavailable — attribution is best-effort only
  }
}

export function getAttribution() {
  try {
    return JSON.parse(sessionStorage.getItem(KEY)) || {};
  } catch (_) {
    return {};
  }
}
